import styled, { createGlobalStyle } from 'styled-components';

export const RootStyle = createGlobalStyle`
  /* Font imports removed from createGlobalStyle. Add the following link tags into your public/index.html <head> instead:
     <link href="https://fonts.googleapis.com/css?family=Passion+One&display=swap" rel="stylesheet">
     <link href="https://fonts.googleapis.com/css?family=Chivo&display=swap" rel="stylesheet">
  */
  :root {
    font-size: 16px;
    line-height: 24px;

    h1, h2, h3, h4, h5, h6 {
      font-family: ${(props: any) => props.theme.typography.defaultFontFamily}, sans-serif;
      margin-top: 0px;
    margin-bottom: 1rem;
    }
    
    p, span {
      font-family: "Chivo";
    }

    body {
      margin: 0;
      position: relative;
    }
  }
`;

export const StyledApp = styled.div`
  /* min-height: 100vh; */
  position: relative;
  padding-bottom: 532px;

  @media screen and (min-width: ${(props: any) => props.theme.breakpoints.sm}) {
    padding-bottom: 284px;
  }

  @media screen and (min-width: ${(props: any) => props.theme.breakpoints.lg}) {
    padding-bottom: 227px;
  }
`;
